import "./product-block.scss";

(function () {
    if (document.querySelectorAll(".product-block").length > 0) {        
        const productBlock = {
            init: () => {
                const buttons = document.querySelectorAll(".product__button");

                buttons.forEach(button => button.addEventListener("click", (e) => {
                    const button = e.currentTarget;

                    if (button) {
                        const carousel = document.querySelector(".product-block .product__carousel");
                        const selectedProduct = button.getAttribute("data-index");
                        const scrollWidth = selectedProduct * carousel.getBoundingClientRect().width;

                        carousel.style.transform = "translateX(calc(-" + scrollWidth + "px))";

                        buttons.forEach(b => b.classList.remove("selected"));
                        button.classList.add("selected");

                        productBlock.updateMobileLabel();
                    }
                }));

                buttons[0].classList.add("selected");

                productBlock.updateMobileLabel();
            },
            updateMobileLabel: () => {
                const selectedButton = document.querySelector(".product__button.selected .button__caption span");
                const selectedButtonText = selectedButton.textContent;
                const selectedButtonLabelContainer = document.querySelector(".button__caption--mobile");

                if (selectedButtonText !== null) {
                    selectedButtonLabelContainer.textContent = selectedButtonText;
                }
            }
        }

        productBlock.init();
    }
})();
